import React from "react"
import styled from "styled-components"

const IconContainer = styled.div`
  width: ${props => props.w * 2}px;
  height: ${props => props.h * 2}px;
  background-color: #CE0101;
  border-radius: 50%;
  padding: 25px 25px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -${props => props.h}px;
`
const Icon = styled.img`
  width: 100%;
  height: 100%;
`


const CardTopIcon = (props) => {

  return (
    <IconContainer {...props}>
      <Icon {...props}></Icon>
    </IconContainer>
  )

}

export default CardTopIcon;